import { Env } from '@/shared/config/environment';
import { HttpClient } from '@/shared/lib/http-client';

export const takePetsContract = async (contractId) => {
  const response = await HttpClient.post(`${Env.server.mode}/insurance/pets/contract/take`, {
    contractId,
  });

  return response.data;
};